import type { OrganizationState } from '../../types';
import type { RiskAssessmentViewModel } from '@trinnvis/dabih-api-client';

import type { InfosecDataItem } from '../../../pages/computers-page/infosec-procedure/infosecDataItem';

export function riskAssessmentNameWithSubstance(
  organization: OrganizationState,
  riskAssessment: RiskAssessmentViewModel,
  dataItems: InfosecDataItem[],
) {
  if (riskAssessment.relatedDataItem) {
    const d = dataItems.find((x) => x.uuid === riskAssessment.relatedDataItem);
    return (d?.name ?? '') + ': ' + riskAssessment.name;
  }
  if (riskAssessment.relatedSubstance) {
    return (organization.substancesById[riskAssessment.relatedSubstance].name ?? '') + ': ' + riskAssessment.name;
  }
  return riskAssessment.name ?? '';
}
